import React from "react";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      minWidth: 0,
      padding: theme.spacing(3),
      paddingTop: 0,
      "& .MuiTableContainer-root": {
        maxHeight: "calc(100vh - 320px)",
      },
    },
  })
);

interface ContentProps {
  children?: React.ReactNode;
  className?: string;
}

const Content: React.FC<ContentProps> = (props) => {
  const { children, className } = props;
  const classes = useStyles();
  return (
    <main className={clsx(classes.content, className)}>
      <Toolbar />
      {children}
    </main>
  );
};

export default Content;
